(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maatwerk-configurator"] && !Shopify.designMode) return;
  try {
    
(function(){
  var roots=document.querySelectorAll('[data-ef-root]');
  var root=roots.length ? roots[roots.length-1] : null;
  if(!root || root.dataset.efReady==='1') return;
  root.dataset.efReady='1';

  var steps=root.querySelectorAll('.ef-step');
  var progress=root.querySelectorAll('.ef-progress-item');
  var back=root.querySelector('[data-back]');
  var skip=root.querySelector('[data-skip]');
  var designNext=root.querySelector('[data-design-next]');
  var designLock=root.querySelector('[data-design-lock]');
  var designReady=root.querySelector('[data-design-ready]');
  var service=root.querySelector('[data-service]');
  var form=root.querySelector('#ef-form');
  var status=root.querySelector('[data-status]');
  var upload=root.querySelector('[data-upload]');
  var fileCard=root.querySelector('[data-file-card]');
  var fileName=root.querySelector('[data-file-name]');
  var replaceFile=root.querySelector('[data-replace-file]');
  var canvas=root.querySelector('[data-canvas]');
  var previewLightbox=document.getElementById('ef-preview-modal-'+root.id.replace(/^ef-/,''));
  if(!previewLightbox){
    previewLightbox=document.querySelector('[data-preview-modal]');
  }
  var previewLightboxImage=previewLightbox ? previewLightbox.querySelector('[data-preview-lightbox-image]') : null;
  var confettiLayer=previewLightbox ? previewLightbox.querySelector('[data-confetti-layer]') : null;
  var currentStep=1;
  var maxReached=1;
  var timer=null;
  var designConfirmed=false;
  var designPresent=false;
  var previewObjectUrl=null;
  var aiEndpoint=root.dataset.aiEndpoint || '';
  var aiUsed=0;
  var aiRound=1;
  var aiStage=0;
  var aiSelected=null;
  var aiHistory=[];
  var aiAdjustments=[];
  var aiBusy=false;
  var aiFileInput=root.querySelector('[data-ai-file]');
   var aiArtwork=null;
   var proofFileInput=root.querySelector('[data-proof-file]');
   var proofLogo=root.dataset.proofLogo||'';
   var proofBlob=null;
  var aiSubStep=1;
  var aiSubMax=1;

  function loadPdfJs(){
    if(window.pdfjsLib){
      window.pdfjsLib.GlobalWorkerOptions.workerSrc='https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
      return Promise.resolve(window.pdfjsLib);
    }

    if(window.efPdfJsPromise){
      return window.efPdfJsPromise;
    }

    window.efPdfJsPromise=new Promise(function(resolve,reject){
      var script=document.createElement('script');
      script.src='https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
      script.onload=function(){
        if(window.pdfjsLib){
          window.pdfjsLib.GlobalWorkerOptions.workerSrc='https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
          resolve(window.pdfjsLib);
        }else{
          reject(new Error('PDF preview kon niet worden geladen.'));
        }
      };
      script.onerror=function(){
        reject(new Error('PDF preview kon niet worden geladen.'));
      };
      document.head.appendChild(script);
    });

    return window.efPdfJsPromise;
  }

  var addonVelcro=Number(root.dataset.addonVelcro)||0;
  var addonPin=Number(root.dataset.addonPin)||0;
  var addonService=Number(root.dataset.addonService)||0;

  function checked(name){
    return root.querySelector('input[name="'+name+'"]:checked');
  }

  function money(cents){
    return new Intl.NumberFormat('nl-NL',{
      style:'currency',
      currency:root.dataset.currency || 'EUR'
    }).format((Number(cents)||0)/100);
  }

  function setDesignState(present,confirmed){
    designPresent=!!present;
    designConfirmed=!!confirmed;

    if(designNext) designNext.classList.toggle('hide',!designPresent);
    if(designLock) designLock.classList.toggle('hide',designPresent);
    if(designReady) designReady.classList.toggle('hide',!designConfirmed);
    updateSideBuy();
  }

  function canEnter(step){
    if(step<=currentStep) return true;
    if(step<=maxReached) return true;

    if(step>=2 && !checked('properties[Uitvoering]')) return false;
    if(step>=3 && !checked('ef_quantity')) return false;
    if(step>=4 && !checked('properties[Achterkant]')) return false;
    if(step>=5 && !designConfirmed) return false;
    return step<=maxReached+1;
  }

  function show(n){
    n=Math.max(1,Math.min(6,Number(n)||1));
    if(!canEnter(n)) return;

    currentStep=n;
    if(n>maxReached) maxReached=n;

    steps.forEach(function(el){
      el.classList.toggle('on',Number(el.dataset.step)===n);
    });

    progress.forEach(function(el,index){
      var s=index+1;
      el.classList.toggle('on',s===n);
      el.classList.toggle('done',s<n);
      el.style.opacity=(s<=maxReached || s===n)?'1':'.45';
    });

    var t=root.querySelector('#ef-steptext');
    if(t) t.textContent='Stap '+n+' van 6';
    if(back) back.style.visibility=n===1?'hidden':'visible';
    if(skip) skip.classList.toggle('hide',n!==5);
    update();
  }

  function nextSoon(){
    clearTimeout(timer);
    timer=setTimeout(function(){
      var target=currentStep+1;
      if(target>maxReached) maxReached=target;
      show(target);
    },320);
  }

  function updateCommercialChoices(){
    var qtyInputs=Array.from(root.querySelectorAll('input[name="ef_quantity"]'));
    if(qtyInputs.length){
      var first=qtyInputs.slice().sort(function(a,b){return Number(a.dataset.pieces)-Number(b.dataset.pieces);})[0];
      var firstPieces=Number(first.dataset.pieces)||1;
      var firstUnit=(Number(first.dataset.price)||0)/firstPieces;
      qtyInputs.forEach(function(input){
        var pieces=Number(input.dataset.pieces)||0;
        var total=Number(input.dataset.price)||0;
        var unit=pieces?total/pieces:0;
        var card=input.nextElementSibling;
        if(!card) return;
        var totalEl=card.querySelector('[data-qty-total]');
        var saveEl=card.querySelector('[data-qty-saving]');
        var badge=card.querySelector('[data-qty-badge]');
        if(totalEl) totalEl.textContent=money(total)+' totaal';
        if(saveEl){
          var saving=Math.max(0,firstUnit-unit);
          saveEl.textContent=saving>=50 ? 'Bespaar '+money(Math.round(saving))+' p/st. t.o.v. '+firstPieces+' stuks' : '';
        }
        if(badge){badge.classList.remove('show');badge.textContent='';}
        if(pieces===50 && badge){badge.textContent='🔥 SLIMME KEUZE';badge.classList.add('show');}
        if(pieces===100 && badge){badge.textContent='POPULAIR';badge.classList.add('show');}
      });
    }

    var selectedQty=checked('ef_quantity');
    var pieces=selectedQty ? Number(selectedQty.dataset.pieces)||0 : 0;

    var deal=root.querySelector('[data-qty-deal]');
    if(deal){
      if(!selectedQty){
        deal.classList.add('hide');
      }else{
        var currentPrice=Number(selectedQty.dataset.price)||0;
        var sorted=qtyInputs.slice().sort(function(a,b){return Number(a.dataset.pieces)-Number(b.dataset.pieces);});
        var next=sorted.find(function(x){return Number(x.dataset.pieces)>pieces;});
        if(!next){
          deal.classList.add('hide');
        }else{
          var np=Number(next.dataset.pieces)||0;
          var nt=Number(next.dataset.price)||0;
          var diff=nt-currentPrice;
          var extra=np-pieces;
          var title=deal.querySelector('[data-qty-deal-title]');
          var text=deal.querySelector('[data-qty-deal-text]');
          var button=deal.querySelector('[data-qty-deal-button]');
          if(title) title.textContent=extra+' extra voor maar '+money(diff)+' meer';
          if(text) text.textContent='Ga naar '+np+' stuks voor '+money(nt)+' totaal · '+money(Math.round(nt/np))+' p/st.';
          if(button){button.dataset.variant=next.value;button.textContent='JA, '+np+' STUKS →';}
          deal.classList.remove('hide');
        }
      }
    }
    root.querySelectorAll('input[name="properties[Achterkant]"]').forEach(function(input){
      var line=input.parentElement ? input.parentElement.querySelector('[data-back-total]') : null;
      if(!line) return;
      var each=Number(input.dataset.extra)||0;
      if(!each){line.textContent='✓ Geen meerprijs';return;}
      line.textContent=pieces ? '+ '+money(each*pieces)+' totaal bij '+pieces+' stuks' : 'Kies je aantal voor de totaalprijs';
    });
  }

  function update(){
    updateCommercialChoices();
    var tech=checked('properties[Uitvoering]');
    var qty=checked('ef_quantity');
    var backing=checked('properties[Achterkant]');

    var pTech=root.querySelector('[data-preview-tech]');
    var pQty=root.querySelector('[data-preview-qty]');
    var pBack=root.querySelector('[data-preview-back]');
    var fTech=root.querySelector('[data-final-tech]');
    var fQty=root.querySelector('[data-final-qty]');
    var fBack=root.querySelector('[data-final-back]');

    if(pTech) pTech.textContent=tech?tech.value:'Uitvoering';
    if(pBack) pBack.textContent=backing?backing.value:'Achterkant';
    if(fTech) fTech.textContent=tech?tech.value:'Nog kiezen';
    if(fBack) fBack.textContent=backing?backing.value:'Nog kiezen';

    if(!qty){
      if(pQty) pQty.textContent='Aantal';
      if(fQty) fQty.textContent='Nog kiezen';
      root.querySelector('[data-base-price]').textContent='—';
      root.querySelector('[data-total-price]').textContent='—';
      root.querySelector('[data-unit-price]').textContent='Kies eerst het aantal';
      root.querySelector('[data-extra-row]').classList.add('hide');
      root.querySelector('[data-service-row]').classList.toggle('hide',!(service&&service.checked));
      updateUpsell();
      updateSideBuy();
      return;
    }

    var pieces=Number(qty.dataset.pieces)||0;
    var base=Number(qty.dataset.price)||0;
    var extraEach=backing?Number(backing.dataset.extra)||0:0;
    var extra=extraEach*pieces;
    var servicePrice=service&&service.checked?7500:0;
    var total=base+extra+servicePrice;

    root.querySelector('#ef-variant').value=qty.value;
    if(pQty) pQty.textContent=pieces+' stuks';
    if(fQty) fQty.textContent=pieces+' stuks';
    root.querySelector('[data-base-price]').textContent=money(base);
    root.querySelector('[data-total-price]').textContent=money(total);
    root.querySelector('[data-unit-price]').textContent=money(Math.round(total/pieces))+' per embleem';

    var er=root.querySelector('[data-extra-row]');
    if(backing&&extra>0){
      er.classList.remove('hide');
      root.querySelector('[data-extra-label]').textContent=backing.value+' · '+money(extraEach)+' × '+pieces;
      root.querySelector('[data-extra-price]').textContent='+ '+money(extra);
    }else{
      er.classList.add('hide');
    }

    root.querySelector('[data-service-row]').classList.toggle('hide',!(service&&service.checked));
    updateUpsell();
    updateSideBuy();
  }

  function updateSideBuy(){
    var btn=root.querySelector('[data-side-buy]');
    var note=root.querySelector('[data-side-buy-note]');
    if(!btn) return;
    var basics=!!checked('properties[Uitvoering]') && !!checked('ef_quantity') && !!checked('properties[Achterkant]');
    var ready=basics && designPresent;
    btn.disabled=!ready;
    btn.textContent='BESTELLEN & VEILIG AFREKENEN →';
    if(note){
      if(ready) note.textContent='Bestelt exact het ontwerp dat hierboven staat · daarna naar winkelwagen';
      else if(!basics) note.textContent='Kies eerst uitvoering, aantal en achterkant';
      else note.textContent='Maak of upload eerst je ontwerp';
    }
  }

  function updateUpsell(){
    var box=root.querySelector('[data-upsell]');
    if(!box) return;
    var qty=checked('ef_quantity');
    if(!qty){box.classList.add('hide');return;}
    var currentPieces=Number(qty.dataset.pieces)||0;
    var currentBase=Number(qty.dataset.price)||0;
    var options=Array.from(root.querySelectorAll('input[name="ef_quantity"]')).map(function(x){
      return {el:x,pieces:Number(x.dataset.pieces)||0,price:Number(x.dataset.price)||0};
    }).filter(function(x){return x.pieces>currentPieces;}).sort(function(a,b){return a.pieces-b.pieces;});
    if(!options.length){box.classList.add('hide');return;}
    var next=options[0];
    var backing=checked('properties[Achterkant]');
    var extraEach=backing?Number(backing.dataset.extra)||0:0;
    var servicePrice=service&&service.checked?7500:0;
    var currentTotal=currentBase+(extraEach*currentPieces)+servicePrice;
    var nextTotal=next.price+(extraEach*next.pieces)+servicePrice;
    var difference=nextTotal-currentTotal;
    var extraPieces=next.pieces-currentPieces;
    var title=root.querySelector('[data-upsell-title]');
    var txt=root.querySelector('[data-upsell-text]');
    var btn=root.querySelector('[data-upsell-button]');
    if(title) title.textContent=extraPieces+' extra emblemen voor '+money(difference)+' meer';
    if(txt) txt.textContent='Ga van '+currentPieces+' naar '+next.pieces+' stuks · '+money(Math.round(nextTotal/next.pieces))+' per embleem.';
    if(btn){btn.dataset.variant=next.el.value;btn.textContent='JA, '+next.pieces+' STUKS →';}
    box.classList.remove('hide');
  }

  function showUploadedPreview(file){
    if(previewObjectUrl){
      URL.revokeObjectURL(previewObjectUrl);
      previewObjectUrl=null;
    }

    canvas.classList.add('has-user-design');
    canvas.innerHTML='';

    if(file.type==='application/pdf' || /\.pdf$/i.test(file.name)){
      var loading=document.createElement('div');
      loading.className='ef-pdf-preview';
      loading.innerHTML='<span>⏳</span><b>PDF wordt geladen…</b><small></small>';
      loading.querySelector('small').textContent=file.name;
      canvas.appendChild(loading);

      loadPdfJs()
      .then(function(){
        return file.arrayBuffer();
      })
      .then(function(buffer){
        return window.pdfjsLib.getDocument({data:buffer}).promise;
      })
        .then(function(pdf){
          return pdf.getPage(1);
        })
        .then(function(page){
          var baseViewport=page.getViewport({scale:1});
          var target=1200;
          var scale=Math.min(3,target/Math.max(baseViewport.width,baseViewport.height));
          var viewport=page.getViewport({scale:scale});
          var pdfCanvas=document.createElement('canvas');
          var ctx=pdfCanvas.getContext('2d',{alpha:false});
          pdfCanvas.width=Math.ceil(viewport.width);
          pdfCanvas.height=Math.ceil(viewport.height);

          return page.render({
            canvasContext:ctx,
            viewport:viewport,
            background:'white'
          }).promise.then(function(){
            return pdfCanvas;
          });
        })
        .then(function(pdfCanvas){
          var img=document.createElement('img');
          img.className='ef-preview-img user-design';
          img.alt='Voorbeeld van de eerste pagina van jouw PDF';
          img.src=pdfCanvas.toDataURL('image/png');
          canvas.innerHTML='';
          canvas.appendChild(img);
        })
      .catch(function(){
        showPdfFallback(file);
      });
    }else{
      var img=document.createElement('img');
      img.className='ef-preview-img user-design';
      img.alt='Jouw geüploade ontwerp';
      previewObjectUrl=URL.createObjectURL(file);
      img.src=previewObjectUrl;
      canvas.appendChild(img);
    }

    if(fileName) fileName.textContent=file.name;
    if(fileCard) fileCard.classList.remove('hide');
    setDesignState(true,false);
  }

  function showPdfFallback(file){
    canvas.innerHTML='';
    var fail=document.createElement('div');
    fail.className='ef-pdf-preview';
    fail.innerHTML='<span>📄</span><b>PDF ontvangen</b><small></small>';
    fail.querySelector('small').textContent='Preview kon niet worden gemaakt · '+file.name;
    canvas.appendChild(fail);
  }

  function firePreviewConfetti(){
    if(!confettiLayer) return;
    confettiLayer.innerHTML='';
    var colors=['#f3d64e','#ff6b9a','#65c7f7','#77d98b','#ff914d','#9b7cff','#ffffff'];
    for(var i=0;i<46;i++){
      var piece=document.createElement('i');
      piece.className='ef-confetti-piece';
      piece.style.left=(Math.random()*100)+'%';
      piece.style.setProperty('--confetti',colors[i%colors.length]);
      piece.style.setProperty('--delay',(Math.random()*.38)+'s');
      piece.style.setProperty('--dur',(1.65+Math.random()*1.15)+'s');
      piece.style.setProperty('--drift',(-80+Math.random()*160)+'px');
      piece.style.setProperty('--spin',(-540+Math.random()*1080)+'deg');
      piece.style.width=(5+Math.random()*6)+'px';
      piece.style.height=(8+Math.random()*10)+'px';
      confettiLayer.appendChild(piece);
    }
    setTimeout(function(){if(confettiLayer) confettiLayer.innerHTML='';},3400);
  }

  function openPreviewLightbox(){
    if(!previewLightbox || !previewLightboxImage || !canvas) return;
    var img=canvas.querySelector('.ef-preview-img');
    if(!img || !img.src) return;
    previewLightboxImage.src=img.currentSrc || img.src;
    previewLightboxImage.setAttribute('draggable','false');
    previewLightbox.classList.add('is-open');
    previewLightbox.setAttribute('aria-hidden','false');
    document.body.classList.add('ef-preview-lightbox-lock');
    firePreviewConfetti();
  }

  function closePreviewLightbox(){
    if(!previewLightbox) return;
    previewLightbox.classList.remove('is-open');
    previewLightbox.setAttribute('aria-hidden','true');
    document.body.classList.remove('ef-preview-lightbox-lock');
  }

  if(canvas){
    canvas.addEventListener('click',function(e){
      if(e.target.closest('.ef-preview-img')) openPreviewLightbox();
    });
  }

  if(previewLightbox){
    previewLightbox.addEventListener('click',function(e){
      if(e.target.closest('[data-preview-close]')) closePreviewLightbox();
    });
  }

  /* V12.5: voorkom de eenvoudige browseracties waarmee een conceptafbeelding wordt opgeslagen. */
  [canvas,previewLightbox].forEach(function(area){
    if(!area) return;
    area.addEventListener('contextmenu',function(e){
      if(e.target.closest('img') || e.target.closest('[data-protected-preview]')) e.preventDefault();
    });
    area.addEventListener('dragstart',function(e){
      if(e.target.closest('img')) e.preventDefault();
    });
    area.addEventListener('copy',function(e){
      if(e.target.closest && (e.target.closest('img') || e.target.closest('[data-protected-preview]'))) e.preventDefault();
    });
  });

  /* Detail popups: handle these BEFORE card selection/auto-advance. */
  var infoModal=root.querySelector('[data-ef-modal]');
  if(!infoModal && root.nextElementSibling && root.nextElementSibling.matches('[data-ef-modal]')){
    infoModal=root.nextElementSibling;
  }

  function openInfoModal(which){
    if(!infoModal) return;
    var panels=infoModal.querySelectorAll('[data-ef-panel]');
    panels.forEach(function(panel){
      panel.hidden=panel.getAttribute('data-ef-panel')!==which;
    });
    infoModal.classList.add('is-open');
    infoModal.setAttribute('aria-hidden','false');
    document.body.classList.add('ef-modal-lock');
  }

  function closeInfoModal(){
    if(!infoModal) return;
    infoModal.classList.remove('is-open');
    infoModal.setAttribute('aria-hidden','true');
    document.body.classList.remove('ef-modal-lock');
  }

  if(infoModal){
    infoModal.addEventListener('click',function(e){
      if(e.target.closest('[data-ef-close]')){
        e.preventDefault();
        closeInfoModal();
      }
    });
  }

  /* Cards: explicit click handling, including clicking an already checked option. */
  root.addEventListener('click',function(e){
    var info=e.target.closest('[data-ef-info]');
    if(info && root.contains(info)){
      e.preventDefault();
      e.stopPropagation();
      openInfoModal(info.getAttribute('data-ef-info'));
      return;
    }

    var close=e.target.closest('[data-ef-close]');
    if(close && root.contains(close)){
      e.preventDefault();
      e.stopPropagation();
      closeInfoModal();
      return;
    }

    var pb=e.target.closest('.ef-progress-item');
    if(pb && root.contains(pb)){
      var target=Number(pb.dataset.go);
      if(canEnter(target)) show(target);
      return;
    }

    var card=e.target.closest('.ef-card');
    if(card && root.contains(card)){
      var input=card.querySelector('input[type="radio"]');
      if(input){
        input.checked=true;
        input.dispatchEvent(new Event('change',{bubbles:true}));
      }
      return;
    }

    var ql=e.target.closest('.ef-qtys label');
    if(ql && root.contains(ql)){
      var q=ql.querySelector('input[type="radio"]');
      if(q){
        q.checked=true;
        q.dispatchEvent(new Event('change',{bubbles:true}));
      }
    }
  });

  document.addEventListener('keydown',function(e){
    if(e.key==='Escape' && infoModal && infoModal.classList.contains('is-open')){
      closeInfoModal();
    }
    if(e.key==='Escape' && previewLightbox && previewLightbox.classList.contains('is-open')){
      closePreviewLightbox();
    }
  });

  root.addEventListener('change',function(e){
    var el=e.target;

    if(el.tagName==='INPUT' && el.name==='properties[Uitvoering]'){
      update();
      updateThreadVisibility();
      if(currentStep===1) nextSoon();
    }

    if(el.tagName==='INPUT' && el.name==='ef_quantity'){
      update();
      if(currentStep===2) nextSoon();
    }

    if(el.tagName==='INPUT' && el.name==='properties[Achterkant]'){
      update();
      if(currentStep===3) nextSoon();
    }

    if(el.tagName==='INPUT' && el.name==='properties[Ontwerpmethode]'){
      var ai=root.querySelector('#ef-ai');
      var up=root.querySelector('#ef-uploadbox');

      /* Changing method invalidates a previously confirmed design. */
      setDesignState(false,false);

      if(el.value==='AI'){
        ai.classList.remove('hide');
        updateThreadVisibility();
        up.classList.add('hide');
      }else{
        ai.classList.add('hide');
        up.classList.remove('hide');
        if(upload && upload.files && upload.files[0]){
          showUploadedPreview(upload.files[0]);
        }
      }
    }

    if(el.hasAttribute('data-service')) update();

    if(el.hasAttribute('data-upload')){
      var file=el.files&&el.files[0];
      if(!file) return;
      showUploadedPreview(file);
    }
  });

  if(replaceFile){
    replaceFile.addEventListener('click',function(){
      if(upload){
        upload.value='';
        upload.click();
      }
    });
  }

  if(designNext){
    designNext.addEventListener('click',function(){
      if(!designPresent) return;
      setDesignState(true,true);
      maxReached=Math.max(maxReached,5);
      setTimeout(function(){show(5)},220);
    });
  }

  function showAiSubStep(n){
    n=Math.max(1,Math.min(5,Number(n)||1));
    if(n>aiSubMax+1) return;
    aiSubStep=n;
    aiSubMax=Math.max(aiSubMax,n);
    root.querySelectorAll('[data-ai-pane]').forEach(function(p){p.classList.toggle('on',Number(p.dataset.aiPane)===n);});
    root.querySelectorAll('[data-ai-go]').forEach(function(b){
      var x=Number(b.dataset.aiGo);
      b.classList.toggle('on',x===n);
      b.classList.toggle('done',x<n);
      b.disabled=x>aiSubMax;
    });
    var prev=root.querySelector('[data-ai-sub-back]');
    var next=root.querySelector('[data-ai-sub-next]');
    var make=root.querySelector('[data-ai-start]');
    if(prev) prev.classList.toggle('hide',n===1);
    if(next) next.classList.toggle('hide',n===5);
    if(make) make.classList.toggle('hide',n!==5);
    updateThreadVisibility();
  }

  function validateAiSubStep(n){
    var b=aiBrief();
    if(n===1 && !b.idea.trim()){root.querySelector('[data-ai-prompt]').focus();return 'Vertel eerst wat je op het embleem wilt.';}
    if(n===2 && !b.style)return 'Kies eerst een stijl.';
    if(n===2 && !b.typography)return 'Kies eerst een letterstijl.';
    if(n===3 && !b.composition)return 'Kies eerst een compositie.';
    if(n===3 && !b.intensity)return 'Kies eerst hoe uitgesproken het ontwerp mag zijn.';
    if(n===3 && !b.creativeFocus)return 'Kies waar AI vooral creatief mee mag zijn.';
    if(n===4 && !b.shape)return 'Kies eerst een vorm.';
    if(n===5 && b.technique==='embroidered' && !b.colors.length)return 'Kies minimaal één garenkleur.';
    return '';
  }

  function aiTechnique(){
    var t=checked('properties[Uitvoering]');
    return t && t.value==='Geborduurd' ? 'embroidered' : 'printed';
  }

  function aiColors(){
    return Array.from(root.querySelectorAll('[data-thread-color]:checked')).map(function(x){return x.value;});
  }

  function syncColors(){
    var selected=aiColors();
    var count=root.querySelector('[data-color-count]');
    var hidden=root.querySelector('[data-thread-value]');
    if(count) count.textContent=selected.length+' / 10';
    if(hidden) hidden.value=selected.join(', ');
    root.querySelectorAll('[data-thread-color]').forEach(function(cb){
      cb.disabled=!cb.checked && selected.length>=10;
    });
  }

  function updateThreadVisibility(){
    var box=root.querySelector('[data-thread-colors]');
    var printed=root.querySelector('[data-print-colors]');
    var embroidered=aiTechnique()==='embroidered';
    if(box) box.classList.toggle('hide',!embroidered);
    if(printed) printed.classList.toggle('hide',embroidered);
  }

  function radioValue(name){
    var el=checked(name);
    return el ? el.value : '';
  }

  function aiBrief(){
    var shape=root.querySelector('input[data-shape]:checked');
    var style=checked('properties[Stijl]');
    return {
      technique:aiTechnique(),
      idea:(root.querySelector('[data-ai-prompt]')||{}).value||'',
      text:(root.querySelector('[data-ai-text]')||{}).value||'',
      style:style?style.value:'',
      shape:shape?shape.dataset.shape:'',
      colors:aiColors(),
      typography:radioValue('properties[Letterstijl]'),
      composition:radioValue('properties[Compositie]'),
      intensity:radioValue('properties[Uitstraling]'),
      creativeFocus:radioValue('properties[AI creativiteit]')
    };
  }

  function enrichedIdea(b,direction){
    var parts=[b.idea];
    if(b.typography) parts.push('Typography direction: '+b.typography+'.');
    if(b.composition) parts.push('Composition preference: '+b.composition+'.');
    if(b.intensity) parts.push('Visual intensity: '+b.intensity+'.');
    if(b.creativeFocus) parts.push('Be especially creative with: '+b.creativeFocus+'.');
    if(direction==='A') parts.push('DESIGN DIRECTION A: Create a distinctive, iconic composition with a strong main illustration. Use a confident silhouette and keep secondary elements restrained. This must feel like one deliberate art direction.');
    if(direction==='B') parts.push('DESIGN DIRECTION B: Create a deliberately DIFFERENT art direction from a typical first option. Change hierarchy, placement, silhouette and relationship between text and illustration. Do not merely recolor or slightly rearrange the same idea.');
    return parts.join(' ');
  }

  function aiValidate(){
    var b=aiBrief();
    if(!b.idea.trim()){root.querySelector('[data-ai-prompt]').focus(); return 'Vertel eerst wat je op het embleem wilt.';}
    if(!b.style){return 'Kies eerst een stijl.';}
    if(!b.shape){return 'Kies eerst een vorm.';}
    if(!b.typography){return 'Kies eerst een letterstijl.';}
    if(!b.composition){return 'Kies eerst een compositie.';}
    if(!b.intensity){return 'Kies eerst hoe uitgesproken het ontwerp mag zijn.';}
    if(!b.creativeFocus){return 'Kies waar AI vooral creatief mee mag zijn.';}
    if(b.technique==='embroidered' && !b.colors.length){return 'Kies minimaal één garenkleur.';}
    return '';
  }

  function aiCounters(){
     var label=aiRound===1 ? 'Ontwerp maken' : 'Gratis aanpassing gebruikt';
     root.querySelectorAll('[data-ai-counter]').forEach(function(el){el.textContent=label;});
     root.querySelectorAll('[data-ai-counter-results]').forEach(function(el){el.textContent=aiRound===1?'Concept':'1 correctie gebruikt';});
  }

  function aiShowError(msg){
    var results=root.querySelector('[data-ai-results]');
    var box=root.querySelector('[data-ai-options]');
    if(results) results.classList.remove('hide');
    if(box) box.innerHTML='<div class="ef-ai-loading"><span>😵</span><b>Dat ging niet helemaal goed</b><small>'+String(msg||'Probeer het nog een keer.')+'</small></div>';
  }

  function aiPost(payload){
    return fetch(aiEndpoint,{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify(payload)
    }).then(function(res){
      return res.json().then(function(data){
        if(!res.ok || !data.ok) throw new Error(data.error || 'AI-aanvraag mislukt.');
        return data;
      });
    });
  }

  function aiLoading(text){
     var box=root.querySelector('[data-ai-options]');
     if(!box) return;
     box.innerHTML='<div class="ef-ai-loading"><span>⚙️</span><b>'+text+'</b><small data-ai-loading-sub>We zetten je idee op de tekentafel…</small></div>';
     var sub=box.querySelector('[data-ai-loading-sub]');
     setTimeout(function(){if(sub&&document.body.contains(sub))sub.textContent='De garenkleuren worden klaargelegd…';},5000);
     setTimeout(function(){if(sub&&document.body.contains(sub))sub.textContent='De laatste draadjes…';},12000);
  }

  function aiRender(images,title,sub){
    var results=root.querySelector('[data-ai-results]');
    var box=root.querySelector('[data-ai-options]');
    if(results) results.classList.remove('hide');
    root.querySelector('[data-ai-result-title]').textContent=title;
    root.querySelector('[data-ai-result-sub]').textContent=sub;
    box.innerHTML='';
    images.forEach(function(item,index){
      var card=document.createElement('button');
      card.type='button';
      card.className='ef-ai-option';
      card.innerHTML='<img alt="AI ontwerp '+(index+1)+'"><footer><span>Jouw concept</span><span>❤️ Kies</span></footer>';
      card.querySelector('img').src=item.image;
      card.addEventListener('click',function(){aiChoose(item,card);});
      box.appendChild(card);
    });
    aiCounters();
  }

  function aiPreview(image){
    canvas.classList.add('has-user-design');
    canvas.innerHTML='';
    var img=document.createElement('img');
    img.className='ef-preview-img user-design';
    img.alt='Jouw AI-concept';
    img.style.cssText='display:block;width:auto;height:auto;max-width:92%;max-height:92%;object-fit:contain;object-position:center;margin:auto;padding:0;';
    img.src=image;
    canvas.appendChild(img);
  }

  function aiChoose(item,card){
    aiSelected=item;
    root.querySelectorAll('.ef-ai-option').forEach(function(x){x.classList.remove('selected');});
    if(card) card.classList.add('selected');
    aiPreview(item.image);
    setDesignState(false,false);

    var decision=root.querySelector('[data-ai-decision]');
    var refine=root.querySelector('[data-ai-refine]');
    var finalAdjust=root.querySelector('[data-ai-final-adjust]');
    var help=root.querySelector('[data-ai-help]');
    if(decision) decision.classList.add('hide');
    if(refine) refine.classList.add('hide');
    if(finalAdjust) finalAdjust.classList.add('hide');
    if(help) help.classList.add('hide');

    if(aiStage===1){
      if(decision) decision.classList.remove('hide');
    }else if(aiStage>=2){
      if(finalAdjust) finalAdjust.classList.remove('hide');
    }
  }

  function dataUriToFile(dataUri,name){
    var parts=dataUri.split(',');
    var mime=(parts[0].match(/:(.*?);/)||[])[1] || 'image/jpeg';
    var binary=atob(parts[1]);
    var bytes=new Uint8Array(binary.length);
    for(var i=0;i<binary.length;i++) bytes[i]=binary.charCodeAt(i);
    return new File([bytes],name,{type:mime});
  }

  function setFileInputFromDataUri(input,dataUri,name){
    if(!input || !dataUri || typeof DataTransfer==='undefined') return;
    try{
      var file=dataUriToFile(dataUri,name);
      var dt=new DataTransfer();
      dt.items.add(file);
      input.files=dt.files;
    }catch(err){console.warn('AI bestand kon niet worden gekoppeld',err);}
  }

  function resizeReference(dataUri,maxSide){
    maxSide=maxSide||510;
    return new Promise(function(resolve,reject){
      var img=new Image();
      img.onload=function(){
        var scale=Math.min(1,maxSide/Math.max(img.naturalWidth||img.width,img.naturalHeight||img.height));
        var w=Math.max(1,Math.round((img.naturalWidth||img.width)*scale));
        var h=Math.max(1,Math.round((img.naturalHeight||img.height)*scale));
        var c=document.createElement('canvas'); c.width=w; c.height=h;
        var ctx=c.getContext('2d',{alpha:false});
        ctx.fillStyle='#ffffff'; ctx.fillRect(0,0,w,h); ctx.drawImage(img,0,0,w,h);
        resolve(c.toDataURL('image/jpeg',0.92));
      };
      img.onerror=function(){reject(new Error('Het ontwerp kon niet worden voorbereid voor de aanpassing.'));};
      img.src=dataUri;
    });
  }

  function attachAiFiles(){
    if(aiArtwork && aiArtwork.image){
      setFileInputFromDataUri(aiFileInput,aiArtwork.image,'ai-ontwerpconcept-'+Date.now()+'.jpg');
    }
  }

  function aiAccept(){
    if(!aiSelected || aiBusy) return;

    /* V10.3: geen extra fysieke AI-render meer.
       Het gekozen platte ontwerp wordt direct vastgezet;
       de fabriek maakt later de echte digitale productieproef. */
    aiArtwork=aiSelected;
    aiSelected=aiArtwork;
    aiPreview(aiArtwork.image);
    attachAiFiles();

    var decision=root.querySelector('[data-ai-decision]');
    var refine=root.querySelector('[data-ai-refine]');
    var finalAdjust=root.querySelector('[data-ai-final-adjust]');
    var done=root.querySelector('[data-ai-done]');
    var gen=root.querySelector('[data-ai-generation]');
    var adj=root.querySelector('[data-ai-adjustments-value]');

    if(decision) decision.classList.add('hide');
    if(refine) refine.classList.add('hide');
    if(finalAdjust) finalAdjust.classList.add('hide');
    if(done) done.classList.remove('hide');

    if(gen) gen.value='V3.4 · gekozen AI ontwerp · '+aiRound+' ontwerpronde(s)';
    if(adj) adj.value=aiAdjustments.join(' | ');

    proofBlob=null;
    setDesignState(true,false);
    aiCounters();
  }

  function generateOne(){
    if(aiBusy) return;
    var err=aiValidate();
    if(err){aiShowError(err); return;}
    aiBusy=true; aiStage=1; aiRound=1; proofBlob=null; setDesignState(false,false);
    root.querySelector('[data-ai-results]').classList.remove('hide');
    root.querySelector('[data-ai-done]').classList.add('hide');
    aiLoading('We zetten je idee op de tekentafel…');
    var b=aiBrief();
    aiPost(Object.assign({mode:'generate_design'},b)).then(function(res){
      aiUsed=1; aiHistory=[res]; aiSelected=res; aiArtwork=res;
      aiRender([res],'Jouw ontwerpconcept','Bekijk je ontwerp rechts. Tevreden? Zet hem vast. Anders kun je één gerichte aanpassing doen.');
      var card=root.querySelector('.ef-ai-option'); if(card) aiChoose(res,card);
    }).catch(function(e){aiShowError(e.message);}).finally(function(){aiBusy=false; aiCounters();});
  }

  function refineOne(){
    if(aiBusy || !aiSelected) return;
    var ta=root.querySelector('[data-ai-adjustment]');
    var adjustment=(ta.value||'').trim();
    if(!adjustment){ta.focus(); return;}
    aiBusy=true; aiStage=2; aiRound=2; aiAdjustments.push(adjustment); setDesignState(false,false);
    aiLoading('We passen alleen jouw gevraagde punt aan…');
    var b=aiBrief();
    resizeReference(aiSelected.image,510).then(function(reference){
      return aiPost(Object.assign({mode:'edit_design',referenceImage:reference,adjustment:adjustment},b));
    }).then(function(res){
      aiUsed+=1; aiHistory.push(res); aiSelected=res; aiArtwork=res;
      aiRender([res],'Aanpassing 1 is klaar','Controleer of jouw wijziging goed is uitgevoerd.');
      var card=root.querySelector('.ef-ai-option'); if(card) aiChoose(res,card);
    }).catch(function(e){aiShowError(e.message);}).finally(function(){aiBusy=false; aiCounters();});
  }

  function finalRefine(){
    if(aiBusy || !aiSelected) return;
    var ta=root.querySelector('[data-ai-final-text]');
    var adjustment=(ta.value||'').trim();
    if(!adjustment){ta.focus(); return;}
    aiBusy=true; aiStage=3; aiRound=3; aiAdjustments.push(adjustment); setDesignState(false,false);
    aiLoading('De laatste draadjes aan het ontwerp…');
    var b=aiBrief();
    resizeReference(aiSelected.image,510).then(function(reference){
      return aiPost(Object.assign({mode:'edit_design',referenceImage:reference,adjustment:adjustment},b));
    }).then(function(res){
      aiUsed+=1; aiHistory.push(res); aiSelected=res; aiArtwork=res;
      aiRender([res],'Laatste aanpassing is klaar','Goed zo? Kies “Deze is goed” om dit ontwerp direct vast te zetten.');
      var card=root.querySelector('.ef-ai-option'); if(card) aiChoose(res,card);
    }).catch(function(e){aiShowError(e.message);}).finally(function(){aiBusy=false; aiCounters();});
  }

  root.querySelectorAll('[data-thread-color]').forEach(function(cb){cb.addEventListener('change',syncColors);});
  root.querySelectorAll('[data-adjust]').forEach(function(btn){btn.addEventListener('click',function(){var ta=root.querySelector('[data-ai-adjustment]'); if(ta && ta.value.indexOf(btn.dataset.adjust)===-1) ta.value=(ta.value?ta.value.trim()+' ':'')+btn.dataset.adjust;});});
  /* V10.2: delegated AI button handling.
     Dit blijft werken wanneer Shopify delen van de section opnieuw rendert. */
  root.addEventListener('click',function(e){
    var btn=e.target.closest('button');
    if(!btn || !root.contains(btn)) return;

    if(btn.matches('[data-ai-sub-next]')){
      e.preventDefault();
      var subErr=validateAiSubStep(aiSubStep);
      if(subErr){alert(subErr);return;}
      aiSubMax=Math.max(aiSubMax,aiSubStep+1);
      showAiSubStep(aiSubStep+1);
      return;
    }
    if(btn.matches('[data-ai-sub-back]')){
      e.preventDefault();
      showAiSubStep(aiSubStep-1);
      return;
    }
    if(btn.matches('[data-ai-go]')){
      e.preventDefault();
      var targetAi=Number(btn.dataset.aiGo)||1;
      if(targetAi<=aiSubMax) showAiSubStep(targetAi);
      return;
    }
    if(btn.matches('[data-side-buy]')){
      e.preventDefault();
      if(!checked('properties[Uitvoering]')){show(1);return;}
      if(!checked('ef_quantity')){show(2);return;}
      if(!checked('properties[Achterkant]')){show(3);return;}
      if(!designPresent){maxReached=Math.max(maxReached,4);show(4);return;}

      /* Bestellen = het ontwerp accepteren dat NU rechts zichtbaar is. */
      if(aiSelected){
        aiArtwork=aiSelected;
        attachAiFiles();
        var gen=root.querySelector('[data-ai-generation]');
        var adj=root.querySelector('[data-ai-adjustments-value]');
        if(gen) gen.value='V4.4 · besteld zichtbaar AI ontwerp · '+aiRound+' ronde(s)';
        if(adj) adj.value=aiAdjustments.join(' | ');
      }
      setDesignState(true,true);
      if(form && form.requestSubmit) form.requestSubmit();
      else {
        var mainBuy=root.querySelector('.ef-buy');
        if(mainBuy) mainBuy.click();
      }
      return;
    }

    if(btn.matches('[data-qty-deal-button]')){
      e.preventDefault();
      var dealVariant=btn.dataset.variant;
      var dealQty=root.querySelector('input[name="ef_quantity"][value="'+dealVariant+'"]');
      if(dealQty){
        dealQty.checked=true;
        dealQty.dispatchEvent(new Event('change',{bubbles:true}));
        update();
      }
      return;
    }

    if(btn.matches('[data-upsell-button]')){
      e.preventDefault();
      var targetVariant=btn.dataset.variant;
      var targetQty=root.querySelector('input[name="ef_quantity"][value="'+targetVariant+'"]');
      if(targetQty){
        targetQty.checked=true;
        targetQty.dispatchEvent(new Event('change',{bubbles:true}));
        update();
        btn.textContent='✓ AANTAL AANGEPAST';
      }
      return;
    }

    if(btn.matches('[data-ai-start]')){
      e.preventDefault();
      e.stopPropagation();
      generateOne();
      return;
    }
    if(btn.matches('[data-ai-open-refine]')){
      e.preventDefault();
      e.stopPropagation();
      var decision=root.querySelector('[data-ai-decision]');
      var refine=root.querySelector('[data-ai-refine]');
      if(decision) decision.classList.add('hide');
      if(refine) refine.classList.remove('hide');
      var adjustment=root.querySelector('[data-ai-adjustment]');
      if(adjustment) setTimeout(function(){adjustment.focus();},50);
      return;
    }
    if(btn.matches('[data-ai-cancel-refine]')){
      e.preventDefault();
      e.stopPropagation();
      var decisionBack=root.querySelector('[data-ai-decision]');
      var refineBack=root.querySelector('[data-ai-refine]');
      if(refineBack) refineBack.classList.add('hide');
      if(decisionBack) decisionBack.classList.remove('hide');
      return;
    }
    if(btn.matches('[data-ai-refine-button]')){
      e.preventDefault();
      e.stopPropagation();
      refineOne();
      return;
    }
    if(btn.matches('[data-ai-accept-now],[data-ai-accept-round1]')){
      e.preventDefault();
      e.stopPropagation();
      aiAccept();
      return;
    }
  });
  var helpButton=root.querySelector('[data-ai-help-button]'); if(helpButton) helpButton.addEventListener('click',function(){
    if(service){service.checked=true; update();}
    var help=(root.querySelector('[data-ai-help-text]')||{}).value||'';
    var wishes=root.querySelector('textarea[name="properties[Speciale wensen]"]');
    if(wishes && help.trim()) wishes.value='Ontwerpservice: '+help.trim();
    aiAccept();
  });

  var proofDownload=root.querySelector('[data-proof-download]');
  if(proofDownload && typeof downloadConceptProof==='function'){
    proofDownload.addEventListener('click',downloadConceptProof);
  }

  if(back) back.addEventListener('click',function(){show(currentStep-1)});
  if(skip) skip.addEventListener('click',function(){maxReached=Math.max(maxReached,6);show(6)});
  root.querySelectorAll('[data-next]').forEach(function(b){
    b.addEventListener('click',function(){
      maxReached=Math.max(maxReached,currentStep+1);
      show(currentStep+1);
    });
  });

  var noExtras=root.querySelector('[data-no-extras]');
  if(noExtras){
    noExtras.addEventListener('change',function(){
      if(!noExtras.checked) return;

      /* Clear only the optional special-wish controls; paid backing/service remain untouched. */
      root.querySelectorAll('input[type="checkbox"]').forEach(function(cb){
        if(cb===noExtras || cb===service) return;
        var n=(cb.name||'').toLowerCase();
        if(n.indexOf('wens')>-1 || n.indexOf('metallic')>-1 || n.indexOf('glitter')>-1 || n.indexOf('patroon')>-1){
          cb.checked=false;
        }
      });

      root.querySelectorAll('textarea').forEach(function(ta){
        var n=(ta.name||'').toLowerCase();
        if(n.indexOf('wens')>-1 || n.indexOf('toelichting')>-1) ta.value='';
      });
    });

    root.addEventListener('change',function(e){
      if(e.target===noExtras) return;
      var n=(e.target.name||'').toLowerCase();
      if((n.indexOf('wens')>-1 || n.indexOf('metallic')>-1 || n.indexOf('glitter')>-1 || n.indexOf('patroon')>-1) && e.target.checked){
        noExtras.checked=false;
      }
    });

    root.addEventListener('input',function(e){
      if(!noExtras.checked) return;
      var n=(e.target.name||'').toLowerCase();
      if((n.indexOf('wens')>-1 || n.indexOf('toelichting')>-1) && String(e.target.value||'').trim()){
        noExtras.checked=false;
      }
    });
  }

  if(form){
    form.addEventListener('submit',function(e){
      e.preventDefault();

      var tech=checked('properties[Uitvoering]');
      var qty=checked('ef_quantity');
      var backing=checked('properties[Achterkant]');
      var method=checked('properties[Ontwerpmethode]');

      if(!tech){show(1);return;}
      if(!qty){show(2);return;}
      if(!backing){show(3);return;}
      if(!method || !designPresent){
        maxReached=Math.max(maxReached,4);
        show(4);
        if(designLock){
          designLock.textContent='🔒 Maak of upload eerst een ontwerp.';
        }
        return;
      }

      /* De bestelling gebruikt altijd exact het ontwerp dat rechts zichtbaar is. */
      if(aiSelected){
        aiArtwork=aiSelected;
        attachAiFiles();
      }
      setDesignState(true,true);

      var pieces=Number(qty.dataset.pieces)||0;
      var addons=[];

      if(backing.dataset.addon==='velcro'){
        addons.push(['Klittenband',addonVelcro,pieces]);
      }
      if(backing.dataset.addon==='pin'){
        addons.push(['Veiligheidsspeld',addonPin,pieces]);
      }
      if(service && service.checked){
        addons.push(['Extra ontwerpservice',addonService,1]);
      }

      var missing=null;
      for(var i=0;i<addons.length;i++){
        if(!addons[i][1]){
          missing=addons[i];
          break;
        }
      }

      if(missing){
        status.textContent='Voor '+missing[0]+' ontbreekt nog het Shopify-toeslagproduct. Metallic, glitter en andere speciale wensen worden hier niet vooraf berekend.';
        return;
      }

      var buy=root.querySelector('.ef-buy');
      var sideBuy=root.querySelector('[data-side-buy]');
      buy.disabled=true;
      if(sideBuy){sideBuy.disabled=true;sideBuy.textContent='EVEN DE FABRIEK IN...';}
      buy.textContent='EVEN DE FABRIEK IN...';
      status.textContent='';

      var fd=new FormData(form);
      fd.set('id',qty.value);
      fd.set('quantity','1');

      fetch(window.Shopify.routes.root+'cart/add.js',{
        method:'POST',
        body:fd,
        headers:{'Accept':'application/json'}
      })
      .then(function(res){
        if(!res.ok){
          throw new Error('Het maatwerkembleem kon niet worden toegevoegd.');
        }
        return res.json();
      })
      .then(function(){
        if(!addons.length){
          return null;
        }

        var items=[];
        for(var j=0;j<addons.length;j++){
          items.push({
            id:addons[j][1],
            quantity:addons[j][2],
            properties:{'_Hoort bij':'Eigen embleem'}
          });
        }

        return fetch(window.Shopify.routes.root+'cart/add.js',{
          method:'POST',
          headers:{
            'Content-Type':'application/json',
            'Accept':'application/json'
          },
          body:JSON.stringify({items:items})
        }).then(function(res){
          if(!res.ok){
            throw new Error('Een gekozen toeslag kon niet worden toegevoegd.');
          }
          return res.json();
        });
      })
      .then(function(){
        window.location.href=window.Shopify.routes.root+'cart';
      })
      .catch(function(err){
        status.textContent=(err && err.message) ? err.message : 'Er ging iets mis. Probeer het opnieuw.';
        buy.disabled=false;
        buy.textContent='BESTELLEN & VEILIG AFREKENEN →';
        if(sideBuy){sideBuy.disabled=false;sideBuy.textContent='BESTELLEN & VEILIG AFREKENEN →';}
        updateSideBuy();
      });
    });
  }

  syncColors();
  updateCommercialChoices();
  updateThreadVisibility();
  aiCounters();
  showAiSubStep(1);
  show(1);
})();

  } catch(e) { console.error(e); }
})();
})();
